module.exports = __webpack_public_path__ + "img/step-4-s.55242294.png";